export const WELCOME_PAGE = {
  primaryColor: "#F37021",
  secondaryColor: "#000000",
  contentContainerColor: "#FFFFFF",
  slideContainerColor: "#000000",
  primaryTextColor: "#FFFFFF",
  secondaryTextColor: "#000000",
};

export const COMMON_COLORS = {
  GRAY: "#333333",
  LIGHT_GRAY: "#EAEAEA",
  ORANGE: "#E4993B",
};

export const SETTING_PAGE = {
  primary: "white",
};

export const ORDER_STATUS_COLORS = {
  ORDER_RECEIVED: "#FFFF00",
  ORDER_SERVED: "#11BB21",
  ORDER_FAILED: "#FF0000",
  ORDER_IN_PROGRESS: "#FFC000",
};

export const SLOT_PASS_COLORS = {
  UPCOMING: "#d0d0d0",
  BOARDING: "#18a532",
  ACIVE: "#f37021",
  EXPIRED: "red",
  CANCELLED: "#ec5050",
};



// WEBPACK FOOTER //
// ./src/utils/Colors.js